import type { BusinessUnit, DistanceUnit, Language } from '@backend/lib-l10n';
import type { Country } from '@backend/lib-shared-types';

import { businessUnits as rawBusinessUnits } from '../../businessUnitConfig';

export type Page = 'jobOffer' | 'apply' | 'cities' | 'sectors' | 'jobs' | 'painPoints' | 'solutions' | 'sitemap';

export type Paths = Record<Page, string>;

export type BusinessUnitConfig = {
  // the name visitors know the employer by
  brandName: string;
  businessUnit: BusinessUnit;
  country: Country;
  currency: 'EUR' | 'USD';
  distanceUnit: DistanceUnit;
  filterCountriesIso3Codes: string[];
  iframe: boolean;
  isProman: boolean;
  language: Lowercase<Language>;
  links: {
    apple_store: string;
    google_store: string;
  };
  locale: string;
  metaImage: string;
  paths: Paths;
};

type BusinessUnitConfigs = Record<BusinessUnit, BusinessUnitConfig>;

// businessUnitConfig.js is CommonJS, so the cast below cannot check its values; its keys are checked here, at
// compile time: a runtime check would import @backend/lib-l10n, and with it moment, into every page's bundle.
type RawBusinessUnitConfig = (typeof rawBusinessUnits)[keyof typeof rawBusinessUnits];
type NonCanonicalBusinessUnit = Exclude<keyof typeof rawBusinessUnits, BusinessUnit>;
const canonicalBusinessUnits: Record<BusinessUnit, RawBusinessUnitConfig> & Record<NonCanonicalBusinessUnit, never> =
  rawBusinessUnits;

export const businessUnits = Object.fromEntries(
  Object.entries(canonicalBusinessUnits).map(([businessUnit, businessUnitConfig]) => [
    businessUnit,
    {
      businessUnit,
      locale: `${businessUnitConfig.language}-${businessUnitConfig.country}`,
      ...businessUnitConfig,
    },
  ]),
) as BusinessUnitConfigs;
